<div id="upload-component-wrapper" [ngClass]="{'active': active}" (drop)="handleDrop($event)"
     (dragover)="handleDragOver($event)">
    <div class="page-wrapper">
        <div class="upload-header">
            <h2>
                @if (!edit) {
                    {{ 'upload.uploadAssets' | translate }}
                } @else {
                    {{ 'upload.editAssets' | translate }}
                }
            </h2>
            @if (!loading) {
                <div class="icon-bar">
                    @if (!edit) {
                        <button mat-raised-button type="button" (click)="this.fileInput?.nativeElement?.click();">
                            {{ 'upload.addassets' | translate }}
                        </button>
                        <input type="file" #filesInput (change)="handleFilesInput($event)" [multiple]="true" style="display: none">
                    }
                    <button mat-icon-button (click)="close()">
                        <mat-icon  fontIcon="close"></mat-icon>
                    </button>
                </div>
            }
        </div>
        <div id="content">
            @if (loading) {
                <div class="loading-indicator">
                    <mat-spinner mode="indeterminate"></mat-spinner>
                </div>
            }
            <div class="row" [ngClass]="{'loading': loading}">
                <section id="metadata" class="col-3">
                    <div class="row">
                        <div class="col-12">
                            <app-upload-master-properties
                                #masterProperties
                                [properties]="uploadProperties"
                                (propertyChange)="masterPropertyChanged($event)">
                            </app-upload-master-properties>
                        </div>
                    </div>
                </section>
                <section id="files" class="col-9">
                    @if (uploadAssets.length === 0) {
                        <div id="drop-indicator">
                            <div class="drop-indicator">
                                <mat-icon fontIcon="cloud_upload"></mat-icon>
                                {{ 'upload.dropFiles' | translate }}
                            </div>
                        </div>
                    }
                    <div id="files-list-container" appFullHigh [bottomOffset]=200>
                        <div class="row row-cols-auto">
                            @for (f of uploadAssets; track f; let i = $index) {
                                <div class="col">
                                    <app-upload-asset
                                        #uploadAsset
                                        [properties]="uploadProperties"
                                        [uploadAsset]="f"
                                        [editMode]="edit"
                                        (fileChange)="fileChanged($event, i)"
                                        (propertiesChanged)="uploadAssetPropertiesChanged($event, i)"
                                        (selectedChange)="selectionChanged($event, i)"
                                        (remove)="removeUpload(i)"
                                        (validChange)="checkFormValid()">
                                    </app-upload-asset>
                                </div>
                            }
                        </div>

                    </div>

                </section>
            </div>
            <div class="row upload-footer">
                <div class="col-12 button-row pt-3">
                    <button type="button" mat-raised-button [disabled]="!canSubmit || submitting" (click)="submit()">
                        {{ 'upload.submit' | translate }}
                    </button>
                </div>
            </div>
        </div>
    </div>
</div>
